<ng-template
  [ngTemplateOutlet]="tpl"
  [ngTemplateOutletContext]="{
    data: data.data,
    instance: snackRef
  }">
</ng-template>
